export const NetConfig = [
  {
    key: 'BSC',
    NetWorkName: 'BSC',
    logoURI: require('@/assets/tokenlogo/BNBnetwork.png'),
    Url: 'https://bsc-dataseed.binance.org',
    blocsUrl: 'https://bscscan.com/tx/',
    blocsHashUrl: 'https://bscscan.com/token/',
    swapConfig: {
      jackRouter: '0xA46FDcA0Ce0173BD80656ccfD6d1cE9d84f0157D',
      jackFactory: '0x5CD2a6e2531b14FFDc005C642D2ACc2159131B27',
      weth: '0xbb4CdB9CBd36B01bD1cBaEBF2De08d9173bc095c',
    },
    chainId: "0x38",
    TokenBNB: {
      name: 'BNB',
      symbol: 'BNB',
      address: '0xbb4CdB9CBd36B01bD1cBaEBF2De08d9173bc095c',
      chainId: 56,
      decimals: 18,
      logoURI: require('@/assets/tokenlogo/BNB.png'),
    }
  },
  {
    key: 'JuChain',
    NetWorkName: 'JuChain',
    logoURI: require('@/assets/img/JuChain.png'),
    Url: 'https://rpc.juchain.org',
    blocsUrl: 'https://juscan.io/tx/',
    blocsHashUrl: 'https://juscan.io/token/',
    swapConfig: {
      jackRouter: '0x53F8A18eBdA929D7C77aE6637475157b90CB41A9',
      jackFactory: '0xD7167e2139A7cb62FAA91cef56d1d7eadC7D1891',
      weth: '0xC66A2f3E9923D495211BFbB051680A8Da7DE5a16',
    },
    chainId: "0x33450",
    TokenBNB: {
      name: 'JU',
      symbol: 'JU',
      address: '0xC66A2f3E9923D495211BFbB051680A8Da7DE5a16',
      chainId: 210000,
      decimals: 18,
      logoURI: require('@/assets/tokenlogo/JU.png'),
    }
  },
]